import { formConvertErrorMessage } from "helpers/form_helper";
import { errorMessage } from "helpers/utils";
import { useTranslation } from "react-i18next";
import { useMutation, useQuery } from "react-query";
import { useToasts } from "react-toast-notifications";
import importManagementService from "services/importManagementService";

// List Import
export const useListImport = (payload, onSuccess, onError) => {
  const { t } = useTranslation(["importManagement"]);
  const { addToast } = useToasts();

  const { params } = payload;

  return useQuery(
    ["imports", params?.page],
    () => importManagementService.listImport(payload),
    {
      enabled: false,
      cacheTime: 0,
      retry: 1,
      onSuccess,
      onError: error => {
        const errorResponse = errorMessage(error);
        addToast(
          formConvertErrorMessage(
            errorResponse.message ||
              t("message.list", {
                target: t("import"),
                status: t("message.error"),
              }),
            t
          ),
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
        if (typeof onError === "function") {
          onError(errorResponse);
        }
      },
      select: response => {
        const { data } = response;
        return {
          items: data.items || [],
          params: params,
          totalCount: data._meta ? data._meta.totalCount : data.items.length,
        };
      },
    }
  );
};

export const useListImportType = (onSuccess, onError) => {
  const { t } = useTranslation(["importManagement"]);
  const { addToast } = useToasts();

  return useQuery(
    ["import-type"],
    () => importManagementService.listImportTypes(),
    {
      enabled: false,
      retry: 1,
      onSuccess,
      onError: error => {
        const errorResponse = errorMessage(error);
        addToast(
          formConvertErrorMessage(
            errorResponse.message ||
              t("message.list", {
                target: t("import"),
                status: t("message.error"),
              }),
            t
          ),
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
        if (typeof onError === "function") {
          onError(errorResponse);
        }
      },
      select: response => {
        const { data } = response;
        return data;
      },
    }
  );
};

export const useDownloadImport = (onSuccess, onError) => {
  const { t } = useTranslation(["importManagement"]);
  const { addToast } = useToasts();

  return useMutation(importManagementService.downloadImport, {
    retry: 0,
    onSuccess,
    onError: error => {
      const errorResponse = errorMessage(error);
      addToast(
        formConvertErrorMessage(
          errorResponse.message ||
            t("message.download", {
              target: t("import"),
              status: t("message.error"),
            }),
          t
        ),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
  });
};

export const useDownloadImportTemplate = (onSuccess, onError) => {
  const { t } = useTranslation(["importManagement"]);
  const { addToast } = useToasts();

  return useMutation(importManagementService.downloadImportTemplate, {
    retry: 0,
    onSuccess: response => {
      const { data } = response;
      if (
        !data.size ||
        data.size === undefined ||
        data.size === null ||
        data.size === 0
      ) {
        return;
      }

      if (typeof onSuccess === "function") {
        onSuccess({
          fileName: "import_template.xlsx",
          file: data,
          fileUrl: URL.createObjectURL(data),
        });
      }
    },
    onError: error => {
      const errorResponse = errorMessage(error);
      addToast(
        formConvertErrorMessage(
          errorResponse.message ||
            t("message.download", {
              target: t("import"),
              status: t("message.error"),
            }),
          t
        ),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
  });
};

export const useUploadResource = (onSuccess, onError) => {
  const { t, i18n } = useTranslation("importManagement");
  const { addToast } = useToasts();

  return useMutation(importManagementService.uploadResource, {
    retry: 2,
    onSuccess,
    onError: error => {
      const errorResponse = errorMessage(error);
      addToast(
        formConvertErrorMessage(
          errorResponse.message || t("upload.choseResourceFail"),
          t
        ),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
  });
};

export const useUploadImport = (onSuccess, onError) => {
  const { t, i18n } = useTranslation("importManagement");
  const { addToast } = useToasts();

  return useMutation(importManagementService.uploadImport, {
    retry: 2,
    onSuccess: response => {
      addToast(t("messages.upload_success"), {
        appearance: "success",
        autoDismiss: true,
      });
      onSuccess && onSuccess(response);
    },
    onError: error => {
      const errorResponse = errorMessage(error);
      addToast(
        formConvertErrorMessage(
          errorResponse.message || t("upload.uploadImportFail"),
          t
        ),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
  });
};

export const useImportDetail = (payload, onSuccess, onError) => {
  const { t, i18n } = useTranslation("importManagement");
  const { addToast } = useToasts();

  return useQuery(
    ["import", "detail"],
    () => importManagementService.importDetail(payload),
    {
      enabled: false,
      retry: 1,
      onSuccess,
      onError: error => {
        const errorResponse = errorMessage(error);
        addToast(
          formConvertErrorMessage(
            errorResponse.message ||
              t("message.list", {
                target: t("import"),
                status: t("message.error"),
              }),
            t
          ),
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
        if (typeof onError === "function") {
          onError(errorResponse);
        }
      },
      select: response => {
        const { data } = response;
        return data;
      },
    }
  );
};
